export default __webpack_public_path__ + "static/media/kitchen5-afterD-480w.1be01c50.webp";